import { connect } from 'react-redux';
import SpinnerComponent from './spinner-component';

const mapStateToProps = (state: any) => ({
  isActive: state.spinner.isActive
});

export default connect(mapStateToProps, {})(SpinnerComponent);
